import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { QuoteFormComponent } from './features/quote-form/quote-form.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'home/',
    component: HomeComponent
  },
  {
    path: 'home',
    redirectTo: 'home/',
    pathMatch: 'full',
  },
  {
    path: 'Home',
    redirectTo: 'home/',
    pathMatch: 'full',
  },
  {
    path: 'about/',
    loadChildren: () =>
      import('./features/company/about/about.module').then(
        (m) => m.AboutModule
      ),
  },
  { path: 'about', redirectTo: 'about/' },

  {
    path: 'careers/',
    loadChildren: () =>
      import('./features/company/career/career.module').then(
        (m) => m.CareerModule
      ),
  },

  { path: 'discuss-project', component: QuoteFormComponent }, 
  { path: 'careers', redirectTo: 'careers/' },
  {
    path: 'jobView',
    loadChildren: () =>
      import('./features/company/job-view/job-view.module').then(
        (m) => m.JobViewModule
      ),
  },

  {
    path: 'sign-up/',
    loadChildren: () =>
      import('./features/signup/signup.module').then((m) => m.SignupModule),
  },
  { path: 'sign-up', redirectTo: 'sign-up/' },
  {
    path: 'refund-policy/',
    loadChildren: () =>
      import('./features/legal/refund-policy/refund-policy.module').then(
        (m) => m.RefundPolicyModule
      ),
  },
  { path: 'refund-policy', redirectTo: 'refund-policy/' },
  {
    path: 'privacy-policy/',
    loadChildren: () =>
      import('./features/legal/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  { path: 'privacy-policy', redirectTo: 'privacy-policy/' },
  {
    path: 'terms-and-conditions/',
    loadChildren: () =>
      import(
        './features/legal/terms-and-conditions/terms-and-conditions.module'
      ).then((m) => m.TermsAndConditionsModule),
  },
  { path: 'terms-and-conditions', redirectTo: 'terms-and-conditions/' },

  {
    path: 'portfolio/',
    loadChildren: () =>
      import('./features/company/portfolio/portfolio.module').then(
        (m) => m.PortfolioModule
      ),
  },
  { path: 'portfolio', redirectTo: 'portfolio/' },

  {
    path: 'service/software-development/',
    loadChildren: () =>
      import(
        './features/services/software-development/software-development.module'
      ).then((m) => m.SoftwareDevelopmentModule),
  },
  {
    path: 'service/software-development',
    redirectTo: 'service/software-development/',
  },

  {
    path: 'service/software-consulting-services/',
    loadChildren: () =>
      import(
        './features/services/software-consulting/software-consulting.module'
      ).then((m) => m.SoftwareConsultingModule),
  },
  {
    path: 'service/software-consulting-services',
    redirectTo: 'service/software-consulting-services/',
  },

  {
    path: 'service/ai/',
    loadChildren: () =>
      import('./features/services/ai/ai.module').then((m) => m.AiModule),
  },
  { path: 'service/ai', redirectTo: 'service/ai/' },

  {
    path: 'service/quantum-computing/',
    loadChildren: () =>
      import(
        './features/services/quantum-computing/quantum-computing.module'
      ).then((m) => m.QuantumComputingModule),
  },
  {
    path: 'service/quantum-computing',
    redirectTo: 'service/quantum-computing/',
  },

  {
    path: 'service/ux-design/',
    loadChildren: () =>
      import('./features/services/ux-design/ux-design.module').then(
        (m) => m.UxDesignModule
      ),
  },
  { path: 'service/ux-design', redirectTo: 'service/ux-design/' },

  {
    path: 'service/digital-marketing/',
    loadChildren: () =>
      import(
        './features/services/digital-marketing/digital-marketing.module'
      ).then((m) => m.DigitalMarketingModule),
  },
  {
    path: 'service/digital-marketing',
    redirectTo: 'service/digital-marketing/',
  },

  {
    path: 'product/transactional-emails/',
    loadChildren: () =>
      import(
        './features/products/transactional-emails/transactional-emails.module'
      ).then((m) => m.TransactionalEmailsModule),
  },
  {
    path: 'product/transactional-emails',
    redirectTo: 'product/transactional-emails/',
  },

  {
    path: 'product/email-verifier/',
    loadChildren: () =>
      import(
        './features/products/email-verification/email-verification.module'
      ).then((m) => m.EmailVerificationModule),
  },
  { path: 'product/email-verifier', redirectTo: 'product/email-verifier/' },

  {
    path: 'product/whatsapp-apis/',
    loadChildren: () =>
      import('./features/products/whatsapp-apis/whatsapp-apis.module').then(
        (m) => m.WhatsappApisModule
      ),
  },
  { path: 'product/whatsapp-apis', redirectTo: 'product/whatsapp-apis/' },

  {
    path: 'resource/branding/',
    loadChildren: () =>
      import(
        './features/resources/branding-resources/branding-resources.module'
      ).then((m) => m.BrandingResourcesModule),
  },
  { path: 'resource/branding', redirectTo: 'resource/branding/' },
{
  path: 'product/aquatech-digital-twin/',
  loadComponent: () =>
    import('./features/products/aquatech-digital-twin/aquatech-digital-twin.component')
      .then(c => c.AquatechDigitalTwinComponent),
},
  
{
  path: 'product/marketing-emails',
  loadComponent: () =>
    import('./features/products/bulk-mailing/bulk-mailing.component')
      .then(c => c.BulkMailingComponent),
},

  { path: 'product/bulk-mailing/', redirectTo: 'product/bulk-mailing' },

  {
    path: 'product/aquatech-digital-twin',
    redirectTo: 'product/aquatech-digital-twin/',
  },
{
  path: 'problem-statement',
  loadComponent: () =>
    import('./features/company/problem-statement/problem-statement.component')
      .then(c => c.ProblemStatementComponent),
},
 

  //  {
  //   path: 'resource/blog/',
  //   component: BlogComponent
  // },
  // { path: 'resource/blog', redirectTo: '/blog/'},

  {
    path: 'contact/',
    loadChildren: () =>
      import('./features/contact/contact.module').then((m) => m.ContactModule),
  },

  { path: 'contact', redirectTo: 'contact/' },
  {
  path: 'internship/programming/',
  loadComponent: () =>
    import('./features/company/internship/programming/programming.component')
      .then(c => c.ProgrammingComponent),
},
{
  path: 'internship/non-programming/',
  loadComponent: () =>
    import('./features/company/internship/non-programming/non-programming.component')
      .then(c => c.NonProgrammingComponent),
},
{
  path: 'internship/apply/',
  loadComponent: () =>
    import('./features/company/internship/apply/apply.component')
      .then(c => c.ApplyComponent),
},

{ path: 'internship/programming', redirectTo: 'internship/programming/' },
{ path: 'internship/non-programming', redirectTo: 'internship/non-programming/' },
{ path: 'internship/apply', redirectTo: 'internship/apply/' },
{ path: 'apply-job/', loadComponent: () => import('./features/company/applyjob/applyjob.component').then(c => c.ApplyjobComponent) },
{ path: 'apply-job', redirectTo: 'apply-job/', pathMatch: 'full' },



{
  path: 'signup/',
  loadComponent: () =>
    import('./features/leads-signup/leads-signup.component')
      .then(c => c.LeadsSignupComponent),
},

{
  path: 'signup',
  redirectTo: 'signup/'
  // pathMatch: 'full',
},

  {
    path: '**',
    loadChildren: () =>
      import('./shared/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      ),
  },
];
